/**
 * Web.Api
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ApplicationUsersGetRolesRoleResponse { 
    id?: string | null;
    label?: string | null;
    color?: string | null;
}

